import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lx-usp',
  templateUrl: './usp.component.html',
  styleUrls: ['./usp.component.scss'],
})
export class UspComponent {}
